import { createContext } from "react";

interface ThreadContext {
  threadId: string;
}

export const ThreadContext = createContext<ThreadContext | undefined>(undefined);
